import type { ReceiptTemplate } from '../schema';

export const ssenseTemplate: ReceiptTemplate = {
  id: 'ssense',
  name: 'SSENSE Receipt',
  brand: 'SSENSE',
  description: 'SSENSE luxury fashion retailer receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ssense-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'SSENSE',
        businessNameFontSize: 20,
        addressLines: [
          '333 RUE CHABANEL OUEST',
          'MONTREAL, QC H2N 2E7',
          'CANADA',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ssense-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'SS-8472910' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ssense-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'ACNE STUDIOS HOODIE', quantity: '1', price: '450.00', sku: '847291034' },
          { id: '2', name: 'MARGIELA TABI BOOTS', quantity: '1', price: '1350.00', sku: '847291035' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ssense-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1800.00', isBold: false, isLarge: false },
          { id: 'shipping', label: 'SHIPPING', value: '0.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '148.50', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1948.50', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ssense-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ssense-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'FREE RETURNS WITHIN 30 DAYS\nWWW.SSENSE.COM\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

